/**
 * Calculate the fee using a flat 8% rate
 * @param {number} ticketPrice - The ticket price in dollars
 * @returns {Object} - Object containing fee breakdown
 */
export function calculateFee(ticketPrice) {
  const flatFeeRate = 0.08; // 8%
  
  // Calculate fee
  const totalFee = ticketPrice * flatFeeRate;
  
  // Amount club receives
  const clubReceives = ticketPrice - totalFee;
  
  return {
    ticketPrice,
    totalFee: parseFloat(totalFee.toFixed(2)),
    clubReceives: parseFloat(clubReceives.toFixed(2)),
    feePercentage: 8.0
  };
}

/**
 * Get a formatted string showing the fee breakdown
 * @param {number} ticketPrice - The ticket price in dollars
 * @returns {string} - Formatted fee breakdown
 */
export function getFeeBreakdownText(ticketPrice) {
  const fee = calculateFee(ticketPrice);
  return `$${fee.totalFee.toFixed(2)} (${fee.feePercentage}%) - Club receives $${fee.clubReceives.toFixed(2)}`;
}

/**
 * Get a detailed breakdown for display
 * @param {number} ticketPrice - The ticket price in dollars
 * @returns {string} - Detailed breakdown text
 */
export function getDetailedBreakdown(ticketPrice) {
  const fee = calculateFee(ticketPrice);
  return `Platform fee: ${fee.feePercentage}% | Total: $${fee.totalFee.toFixed(2)}`;
}